module.exports = __webpack_public_path__ + "static/media/galerija_2019 (35).212ab6e5.jpg";